import zh from './zh.json'
import en from './en.json'

export const resources = {
    "zh": {
        translation: zh
    },
    "en": {
        translation: en
    }
}